// extracted by mini-css-extract-plugin
export default {"editCell":"C_Xnbg_bahQxT_NV7nsK","content":"wBh9lBQdsCRzyN2tKB3A","wrapper":"jhiTGIdMZxIZEVrlyZWe","widthPlaceholder":"HqE7YcDwstYgq9rgDrml","input":"G6hIu60ldXgjnGh7HW6v"};